/**
 * Public front page `/` (Epic 20 S20.2).
 *
 * Vision-first anonymous landing — the conversion surface for the closed-beta
 * waitlist. Composed of five sections in order: Hero → USPs → Esimerkkisadut →
 * Tutustu esimerkkihahmoihin → Signup CTA, wrapped in the shared PublicLayout
 * (top bar `Kirjaudu` + footer). Finnish-only hardcoded copy —
 * Epic 20 public surfaces deliberately do NOT use the i18n framework (exception
 * to CLAUDE.md rule 4, which still governs logged-in app content).
 *
 * Eager-imported in RootRoute (the dashboard HomePage stays lazy) so the public
 * LCP surface does not pay an extra chunk fetch.
 *
 * @module pages/PublicHomePage
 */

import { PublicLayout } from '../components/layout/PublicLayout';
import { Hero } from '../components/originals/home/Hero';
import { UspGrid } from '../components/originals/home/UspGrid';
import { ExampleStories } from '../components/originals/home/ExampleStories';
import { CharacterMeetCards } from '../components/originals/home/CharacterMeetCards';
import { SignupCta } from '../components/originals/home/SignupCta';

export function PublicHomePage(): JSX.Element {
  return (
    <PublicLayout>
      <Hero />
      <UspGrid />
      <ExampleStories />
      <CharacterMeetCards />
      {/*
        Social proof ("Ensimmäiset perheet kertovat") is hidden until we have
        real family testimonials (owner decision 2026-06-13). The SocialProof
        component is kept in place — re-add <SocialProof /> here once real
        quotes replace the lorem-ipsum placeholders.
      */}
      <SignupCta />
    </PublicLayout>
  );
}
